import React from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../../../../helpers/Utils";
import { DATE_FORMAT_LEGACY } from "../../../../constants/Constants";
import { disableInitialExaminationTabToggle } from "../../../../actions/chartSideMedicalFillInFormActions";

const MedicalFillInFormOwnedItem = (props) => {
  const { item } = props;
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state);
  const { openItem, editItem, openAddendumItem, consultationId } = props;
  const currentMemberId = _.get(session, "member.id");
  const memberSpeciality = _.get(session, "speciality");
  const appointmentDoctorId = _.get(item, "appointmentDoctor.id");
  const appointmentDoctorSpeciality = _.get(item, "appointmentDoctor.mainSpeciality");

  const isSameSpeciality =
    appointmentDoctorSpeciality?.id === memberSpeciality?.id ||
    appointmentDoctorSpeciality?.code === memberSpeciality?.code;
  const isOwner = currentMemberId === appointmentDoctorId;
  const isFullAccess = isSameSpeciality && isOwner;

  const disableButtonsBasedOnSpeciality = (type) => {
    switch (type) {
      case "Addendum":
        return !isFullAccess;
      case "Print":
        return false;
      case "View":
        return !isFullAccess;
      case "Edit":
        return !isFullAccess;
      default:
        return false;
    }
  };

  return (
    <div
      role="button"
      className={`btn btn-default chart-clinical-note-item mb-1 ${
        item.consultationId === consultationId ? "medical-fill-in-form-list-item" : ""
      }`}
      style={{
        position: "relative",
        paddingRight: "12px",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <strong>{item.name}</strong>

        <div className="d-flex align-items-center">
          <button
            type="button"
            // disabled={disableButtonsBasedOnSpeciality("Addendum")}
            onClick={() => {
              openAddendumItem(item.id);
            }}
            className="mr-1 btn btn-default btn-sm"
          >
            <span className="font-weight-bold cursor-pointer">Addendum</span>
          </button>
          <button
            type="button"
            // disabled={disableButtonsBasedOnSpeciality("Print")}
            onClick={(e) => {
              e.stopPropagation();

              dispatch(disableInitialExaminationTabToggle(false));
              openItem(item, "print");
            }}
            className="mr-1 btn btn-default btn-sm"
          >
            <span className="font-weight-bold cursor-pointer">Print</span>
          </button>
          <button
            type="button"
            // disabled={disableButtonsBasedOnSpeciality("View")}
            onClick={(e) => {
              e.stopPropagation();

              dispatch(disableInitialExaminationTabToggle(false));
              openItem(item, "view");
            }}
            className="mr-1 btn btn-default btn-sm"
          >
            <span className="font-weight-bold cursor-pointer">View</span>
          </button>
          <button
            type="button"
            // disabled={disableButtonsBasedOnSpeciality("Edit")}
            onClick={(e) => {
              e.stopPropagation();

              dispatch(disableInitialExaminationTabToggle(false));
              editItem(item);
            }}
            className="btn btn-default btn-sm"
          >
            <span className="font-weight-bold cursor-pointer">Edit</span>
          </button>
        </div>
      </div>

      <br />

      <div className="d-flex align-items-center justify-content-between flex-shrink-0 flex-grow-1">
        <div className="d-flex flex-column flex-grow-1 flex-shrink-1 col-gap-2">
          <div style={{ fontSize: "12px", color: "#333" }}>
            by &nbsp;
            {item.appointmentDoctor?.name || item.appointmentDoctor?.fullName}
          </div>
          <div style={{ fontSize: "12px", color: "#333" }}>
            {Utils.parseDateFormat(
              Utils.calcDateWithTimeZone(item.createdDate),
              DATE_FORMAT_LEGACY,
            )}
          </div>
        </div>
        <div className="pr-1">
          {_.get(item, "appointmentDoctor.specialities", []).map((specialty, index, array) => (
            <div key={index}>
              {specialty.name}
              {index < array.length - 1 && ","}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MedicalFillInFormOwnedItem;
